import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from 'react';
import styles from './Tab.module.css';
function getTabIdentity(tab) {
    return tab.id ?? tab.label;
}
function TabComponent({ items, dataTestId, className, contentClassName, style, defaultActiveTab, onTabChange, children, }) {
    const [activeTab, setActiveTab] = useState(() => {
        if (defaultActiveTab && items.some(item => getTabIdentity(item) === defaultActiveTab && !item.disabled)) {
            return defaultActiveTab;
        }
        const firstEnabledTab = items.find(item => !item.disabled);
        return firstEnabledTab ? getTabIdentity(firstEnabledTab) : '';
    });
    useEffect(() => {
        if (defaultActiveTab && items.some(item => getTabIdentity(item) === defaultActiveTab && !item.disabled)) {
            setActiveTab(defaultActiveTab);
        }
    }, [defaultActiveTab]);
    const handleTabClick = (tabIdentity) => {
        if (items.find(t => getTabIdentity(t) === tabIdentity)?.disabled)
            return;
        setActiveTab(tabIdentity);
        onTabChange?.(tabIdentity);
    };
    return (_jsxs("div", { className: `${styles.container} ${className ?? ''}`, style: { ...style }, "data-testid": dataTestId, children: [_jsxs("div", { className: styles.menu, children: [_jsx("div", { className: styles.menuItems, children: items.map(tab => {
                            const identity = getTabIdentity(tab);
                            const hasCount = typeof tab.count === 'number' && tab.count > 0;
                            return (_jsxs("button", { "data-testid": `tab-button-${identity}`, disabled: tab.disabled, onClick: () => handleTabClick(identity), "aria-label": hasCount ? `${tab.label}, ${tab.count} itens` : undefined, className: `${styles.menuItem} ${activeTab === identity ? styles.menuItemActive : ''} ${tab.disabled ? styles.menuItemDisabled : ''}`, children: [tab.label, hasCount && (_jsx("span", { className: styles.menuItemCount, "data-testid": `tab-count-${identity}`, "aria-hidden": 'true', children: tab.count }))] }, identity));
                        }) }), children] }), _jsx("div", { className: `${styles.content} ${contentClassName ?? ''}`, children: items.find(tab => getTabIdentity(tab) === activeTab)?.children })] }));
}
export const Tab = memo(TabComponent);
